import { userConstants } from '../../store/actionTypes';

// const initState = (user && token) ? { loggedIn: true, user, token } : {};
const initState = {
  tokenExpired: false
};

const jwtReducer = (state = initState, action) => {
  switch (action.type) {
    case userConstants.TOKEN_REQUEST:
      return {
        ...state,
        tokenExpired: true,
      };
    case userConstants.TOKEN_REFRESH:
      return state
    case userConstants.TOKEN_VALIDITY:
      return state
    default:
      return state
  }
}
export default jwtReducer;